/**
 * External Dependencies
 */
import React, { useEffect, useState } from 'react';

/**
 * Internal Dependencies
 */
import Main from 'components/main';
import Card from 'components/card';
import Button from 'components/button';
import cscom from 'lib/customer-ec-sdk';
import Preloader from 'components/preloader';
import logo from 'assets/images/tower_logo_black-120.webp';

const WarningIcon = () => (
    <div style={{
        width: 56,
        height: 56,
        borderRadius: '50%',
        backgroundColor: '#fff0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '16px auto',
    }}>
        <svg width='28' height='28' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M12 2L1 21h22L12 2z' stroke='#e53e3e' strokeWidth='2' strokeLinejoin='round' fill='none'/>
            <line x1='12' y1='9' x2='12' y2='14' stroke='#e53e3e' strokeWidth='2' strokeLinecap='round'/>
            <circle cx='12' cy='17.5' r='0.75' fill='#e53e3e' stroke='#e53e3e' strokeWidth='0.5'/>
        </svg>
    </div>
);

const JwtLogin = (props) => {
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        cscom
            .authentication()
            .jwtLogin(props.jwt)
            .then(function(data) {
                localStorage.setItem('currentUserJWT', data.token);
                window.location = '/';
            })
            .catch(function(error) {
                var body = error && error.response && error.response.body;
                var message = (body && body.message) || 'Login failed. Please try again.';
                window.history.replaceState(null, '', '/jwt-login');
                setErrorMessage(message);
            });
    }, []);

    if (errorMessage) {
        return (
            <Main className='signin'>
                <Card className='login-form' style={{ textAlign: 'center' }}>
                    <h3 className='login-form__heading'>Tower Advantage&trade; Login</h3>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '56px' }}>
                        <a href='https://www.towersystems.com.au' target='_blank' rel='noopener noreferrer'>
                            <div style={{
                                width: 100,
                                height: 100,
                                borderRadius: '50%',
                                border: '2px solid #dfdfdf',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                            }}>
                                <img
                                    src={logo}
                                    alt='Tower Systems'
                                    style={{ width: 100, height: 100, objectFit: 'contain' }}
                                />
                            </div>
                        </a>
                    </div>
                    <WarningIcon />
                    <h4 style={{ margin: '0 0 12px', fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>
                        Access Restricted
                    </h4>
                    <p style={{ color: '#555', fontSize: '14px', lineHeight: '1.6', margin: '0 0 56px' }}>
                        {errorMessage}
                    </p>
                    <Button
                        primary
                        className='login-form__submit-btn'
                        onClick={function() { window.location.href = 'https://twc.towersystems.com.au/login'; }}
                    >
                        Back to Sign In
                    </Button>
                </Card>
                <p style={{ color: '#999', fontSize: '12px', textAlign: 'center', marginTop: '16px' }}>
                    &copy; {new Date().getFullYear()}{' '}
                    <a href='https://www.towersystems.com.au' target='_blank' rel='noopener noreferrer' style={{ color: '#999' }}>
                        Tower Systems Pty Ltd
                    </a>
                </p>
            </Main>
        );
    }

    return <Preloader />;
};

export default JwtLogin;
